import {
    Accordion, AccordionDetails, AccordionSummary, Box, Button, Card,
    CardContent, Divider, List, ListItem, ListItemText, Stack, TableCell,
    TableRow, Typography, styled, tableCellClasses
} from '@mui/material';
import BorderColorIcon from "@mui/icons-material/BorderColor";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Dispatch, FC, Fragment, SyntheticEvent, useState } from 'react';
import { btnStyle } from '../user/Tabs/utilisateur/UtilisateurRow';
import OptionalWidthModal from '../../../../commons/optional-width-modal/OptionalWidthModal';
import { DeviseInterface } from '../Article/InterfaceArticle';
import TauxDechangeFormUpdate from '../../../forms/TauxDechange/TauxDechangeFormUpdate';
import { AlertType } from '../../../../types/AlertType';
import { AllMounth } from '../../../../constants/Constants';
import { DataTaux } from './TauxDechange';

const StyledTableCellBody = styled(TableCell)(() => ({
    [`&.${tableCellClasses.body}`]: {
        fontSize: 11,
        textAlign: 'center',
        color: "#fff"
    },
}));

export interface RowToEdit {
    month: number;
    year: number;
    taux: DataTaux[];
}

interface TauxExchangeRowProps {
    month: number;
    year: number;
    headers: string[];
    isDesktopOrLaptop: boolean;
    oneMonthData: DataTaux[];
    allDevise: DeviseInterface[];
    expanded: number | false;
    setExpanded: Dispatch<React.SetStateAction<number | false>>;
    handleReload: () => void;
    setOpenSnack: Dispatch<React.SetStateAction<boolean>>;
    setAlerteMessage: Dispatch<React.SetStateAction<string>>;
    setAlertType: Dispatch<React.SetStateAction<AlertType>>;
}

const TauxExchangeRow: FC<TauxExchangeRowProps> = ({
    headers,
    oneMonthData,
    isDesktopOrLaptop,
    month,
    year,
    allDevise,
    expanded,
    setExpanded,
    handleReload,
    setOpenSnack,
    setAlerteMessage,
    setAlertType
}) => {
    const [openModal, setOpenModal] = useState<boolean>(false);

    const handleClose = () => {
        setOpenModal(false);
    };

    const dataRow = oneMonthData;

    const row: RowToEdit = {
        year: year,
        month: month,
        taux: oneMonthData
    };

    const handleChangeAccordionValue = (panel: number) => (event: SyntheticEvent, isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : false);
    };

    const firstColumn = `${AllMounth.find(elem => elem?.id === month)?.mounth} ${year}`;

    return (
        <>
            {isDesktopOrLaptop ? (
                <TableRow>
                    <StyledTableCellBody>{firstColumn}</StyledTableCellBody>
                    {dataRow?.map((cell, i) => (
                        <StyledTableCellBody key={i}>{cell?.rate_euro}</StyledTableCellBody>
                    ))}
                    <StyledTableCellBody>
                        <Button
                            size="small"
                            variant="outlined"
                            startIcon={<BorderColorIcon />}
                            onClick={() => setOpenModal(true)}
                            sx={btnStyle({
                                bgColor: "#070d23",
                                hoverColor: "Gray",
                                color: "#fff",
                            })}
                        >
                            Modifier
                        </Button>
                    </StyledTableCellBody>
                </TableRow>
            ) : (
                <Accordion
                    expanded={expanded === month}
                    onChange={handleChangeAccordionValue(month)}
                    sx={{
                        borderRadius: 1,
                        bgcolor: "#fff",
                        mb: 1,
                        ml: 0.1
                    }}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: "#080d24" }} />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                    >
                        <Stack direction="column">
                            <List sx={{ py: 0 }} dense>
                                <ListItem sx={{ my: 0, py: 0 }} dense>
                                    <ListItemText primary={firstColumn} />
                                </ListItem>
                            </List>
                        </Stack>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Stack direction="column" spacing={1}>
                            <Button
                                variant="contained"
                                sx={btnStyle({
                                    bgColor: "Gray",
                                    hoverColor: "Gray",
                                    color: "#fff",
                                })}
                                size="small"
                                fullWidth
                                startIcon={<BorderColorIcon />}
                                onClick={() => setOpenModal(true)}
                            >
                                Modifier
                            </Button>

                            <Box mt={5}>
                                <Typography
                                    gutterBottom
                                    variant="h5"
                                    component="div"
                                    sx={{ mb: 0, mt: 2 }}
                                >
                                    Détails
                                </Typography>
                                <Divider
                                    orientation="horizontal"
                                    sx={{ bgcolor: "#fff", mb: 1 }}
                                />
                            </Box>

                            <Card>
                                <CardContent>
                                    <List dense>
                                        {headers?.map((elem, index) => (
                                            <Fragment key={index}>
                                                <ListItem dense>
                                                    <ListItemText
                                                        primary={elem}
                                                        secondary={<Typography variant='caption' color="#FC8404">
                                                            {oneMonthData[index]?.rate_euro}
                                                        </Typography>}
                                                    />
                                                </ListItem>
                                                <Divider
                                                    orientation="horizontal"
                                                    sx={{ bgcolor: " #dfdfdf" }}
                                                />
                                            </Fragment>
                                        ))}
                                    </List>
                                </CardContent>
                            </Card>
                        </Stack>
                    </AccordionDetails>
                </Accordion>
            )}

            <OptionalWidthModal
                title="Modifier Taux d'echange"
                breackPoint="md"
                onClose={handleClose}
                open={openModal}
            >
                <TauxDechangeFormUpdate
                    allDevise={allDevise}
                    row={row}
                    handleReload={handleReload}
                    setOpenSnack={setOpenSnack}
                    setAlerteMessage={setAlerteMessage}
                    setAlertType={setAlertType}
                />
            </OptionalWidthModal>
        </>
    );
}

export default TauxExchangeRow